import { MobiDocument } from './MobiDocument';

export class TarifActiviteElementFriseDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private tarifactivite_id: number;
    private elementfrise_id: number;

    public constructor(tarifActiviteFrise: any) {
        super()
        this._id = tarifActiviteFrise._id;
        this._rev = tarifActiviteFrise._rev;
        this.id = tarifActiviteFrise.id;
        this.tarifactivite_id = tarifActiviteFrise.tarifactivite_id;
        this.elementfrise_id = tarifActiviteFrise.elementfrise_id;
    }
    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getTarifactivite_id(): number {
        return this.tarifactivite_id;
    }

    public setTarifactivite_id(tarifactivite_id: number): void {
        this.tarifactivite_id = tarifactivite_id;
    }

    public getElementfrise_id(): number {
        return this.elementfrise_id;
    }

    public setElementfrise_id(elementfrise_id: number): void {
        this.elementfrise_id = elementfrise_id;
    }

}